import {Moon, Sun} from "lucide-react"
import {Button} from "@/components/ui/button"
import {useTheme} from "@/components/theme-provider"

export function ThemeToggle({className}: { className?: string }) {
    const {theme, toggle} = useTheme()
    return (
        <Button
            variant="ghost"
            size="icon"
            onClick={toggle}
            aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} theme`}
            className={className}
        >
            <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0"/>
            <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100"/>
        </Button>
    )
}
